import { AuthenticationLoginResponseDto } from '../../modules/authentications/dtos/authentication-login-response';
import { GroupName } from '../../shared/enums/groups.enum';

export function isSuperAdmin(
	session: AuthenticationLoginResponseDto | null,
): boolean {
	const userGroups = session?.groups ?? [];

	return userGroups.some((group) => group.name === GroupName.SUPER_USER);
}
